import { render, staticRenderFns } from "./rams-index.vue?vue&type=template&id=b76064ae"
import script from "./rams-index.vue?vue&type=script&lang=js"
export * from "./rams-index.vue?vue&type=script&lang=js"
import style0 from "./rams-index.vue?vue&type=style&index=0&id=b76064ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports